import { WarningFilled } from '@ant-design/icons'
import type { Node, NodeProps } from '@xyflow/react'
import { Tooltip } from 'antd'
import { type RowNodeData, statusDotColor } from './auditLayout'

export type AuditRowNodeType = Node<RowNodeData, 'auditRow'>

export function AuditRowNode({ data }: NodeProps<AuditRowNodeType>) {
  const { label, technicalKey, status, message, showTechnical } = data

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 3,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
        <span
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: statusDotColor(status),
            flex: 'none',
          }}
        />
        <span
          style={{
            fontSize: 14,
            fontWeight: 700,
            color: 'hsl(var(--foreground))',
          }}
        >
          {label}
        </span>
        {status !== 'ok' && message ? (
          <Tooltip title={message} mouseEnterDelay={0}>
            <WarningFilled
              style={{
                color: statusDotColor(status),
                fontSize: 14,
                flex: 'none',
                cursor: 'help',
                // nodes are non-interactive (pointer-events:none) so the canvas
                // stays locked; re-enable events here so the tooltip fires.
                pointerEvents: 'auto',
              }}
            />
          </Tooltip>
        ) : null}
      </div>
      {showTechnical ? (
        <span
          style={{
            fontFamily:
              'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
            fontSize: 10.5,
            color: 'hsl(var(--muted-foreground))',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {technicalKey}
        </span>
      ) : null}
    </div>
  )
}
